<section [class]="'tabs-wrapper ' + styleModifier">
  <div class="tab-element" *ngFor="let tab of tabs; trackBy: trackById"
       [id]="tab.id + '-tab-header'"
       [ngClass]="{'active-tab':tab.name === currentTab}"
       (click)="onTabChange(tab.name)">
    <span class="tab-name Auto_{{tab.id}}" id="{{tab.id}}" translate>{{tab.name}}</span>

    <!-- <span class="tab-counter" *ngIf="tab.count && tab.amount > -1">({{tab.amount}})</span> -->
    <span class="tab-counter" *ngIf="!tab.hideCounter && tab.amount > -1">({{tab.amount}})</span>
    <span class="tab-close" *ngIf="isCloseable" (click)="closeTab(tab.name)">x</span>
  </div>
</section>
